//sample data for ignoreConfig and paramsConfig
// const ignoreConfig = {
// 	container: {
// 	  textAlign: true, // Ignore textAlign inside "container"
// 	},
// 	footer: {
// 	  nested: {
// 		marginLeft: true, // Ignore marginLeft inside "footer.nested"
// 	  },
// 	},
//   };

//   // Pass parameters dynamically for nested objects
//   const paramsConfig = {
// 	container: { darkMode: true }, // Will be passed to container styles
// 	footer: {
// 	  nested: { paddingValue: 20 }, // Will be used for dynamicPadding
// 	},
//   };

export const generateDirStyles = (styles, dir, ignoreKeys = {}, params = {}) => {
	if (dir === "ltr") return styles; // No changes needed for LTR

	const replacements = {
		textAlign: { left: "right", right: "left", start: "end", end: "start" },
		float: { left: "right", right: "left" },
		clear: { left: "right", right: "left" },
		marginLeft: "marginRight",
		marginRight: "marginLeft",
		paddingLeft: "paddingRight",
		paddingRight: "paddingLeft",
		borderLeft: "borderRight",
		borderRight: "borderLeft",
		borderLeftWidth: "borderRightWidth",
		borderRightWidth: "borderLeftWidth",
		borderLeftStyle: "borderRightStyle",
		borderRightStyle: "borderLeftStyle",
		borderLeftColor: "borderRightColor",
		borderRightColor: "borderLeftColor",
		borderTopLeftRadius: "borderTopRightRadius",
		borderTopRightRadius: "borderTopLeftRadius",
		borderBottomLeftRadius: "borderBottomRightRadius",
		borderBottomRightRadius: "borderBottomLeftRadius",
		left: "right",
		right: "left",
		order: (value, parentDisplay) => (parentDisplay === "flex" || parentDisplay === "grid" ? -value : value), // Reverse order only for flex/grid items
		justifyContent: {
			flexStart: "flexEnd",
			flexEnd: "flexStart"
		},
		alignItems: {
			flexStart: "flexEnd",
			flexEnd: "flexStart"
		},
		transform: (value) => {
			return value.replace(/translateX\((-?\d+)(px|%)\)/, (_, num, unit) => {
				return `translateX(${-num}${unit})`;
			});
		},
		transformOrigin: (value) => {
			if (typeof value === "string") {
				return value
					.replace(/\bleft\b/, "temp")
					.replace(/\bright\b/, "left")
					.replace(/\btemp\b/, "right");
			}
			return value;
		},
		boxShadow: (value) => {
			return value.replace(/(-?\d+)px/g, (match, num) => `${-num}px`);
		}
	};

	const processStyles = (obj, ignoreConfig = {}, paramConfig = {}, parentDisplay = "") => {
		let updatedObj = {};

		Object.entries(obj).forEach(([key, value]) => {
			if (ignoreConfig[key] === true) {
				updatedObj[key] = value; // Keep this property unchanged
				return;
			}

			if (typeof value === "function") {
				// If value is a function, check if it returns a nested object
				let resolvedValue = value(dir, paramConfig); // Call function with dir & params
				if (typeof resolvedValue === "object" && !Array.isArray(resolvedValue)) {
					updatedObj[key] = processStyles(
						resolvedValue,
						ignoreConfig[key] || {},
						paramConfig[key] || {},
						obj.display || parentDisplay
					);
				} else {
					updatedObj[key] = resolvedValue; // Use value directly if not an object
				}
			} else if (typeof value === "object" && !Array.isArray(value)) {
				// Recursively process nested objects
				updatedObj[key] = processStyles(
					value,
					ignoreConfig[key] || {},
					paramConfig[key] || {},
					obj.display || parentDisplay
				);
			} else if (replacements[key]) {
				if (typeof replacements[key] === "object") {
					updatedObj[key] = replacements[key][value] || value;
				} else if (typeof replacements[key] === "function") {
					updatedObj[key] = replacements[key](value, obj.display || parentDisplay);
				} else {
					updatedObj[replacements[key]] = value;
				}
			} else {
				updatedObj[key] = value;
			}
		});

		return updatedObj;
	};

	return processStyles(styles, ignoreKeys, params);
};
